/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlayProgress {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    ARCHIVED = 'ARCHIVED',
}
